import { IProjectAttributes } from 'shared/interfaces/IProject';
import { IRoleAttributes } from 'shared/interfaces/IRole';
import { IOpporunitiesContext } from './OpportunitiesContext.types';

const subdomain = window.location.hostname.split('.')[0];
const isJob = subdomain === 'jobs';

export const opportunitiesDefaultStates: IOpporunitiesContext = {
  filters: {
    name: '',
    categories: [] as string[],
    job_types: [] as string[],
    age_range_from: 0,
    age_range_to: 110,
    age_range_type: 'Year' as 'Month' | 'Year',
    location: '',
    cities: [] as string[],
    genders: [] as string[],
    paying_roles: [] as string[],
    unions: [] as string[],
    countries: 'United States',
    // countries: '',
    ...(!isJob && { tab_filter: 'new' as 'new' | 'submitted' | 'not_interested' }),
  },
  setFilters: () => {},
  hideFilters: false,
  setHideFilters: () => {},
  setOnlyFilters: () => {},

  opportunitiesFetching: false,
  fetchMoreOpportunities: () => {},
  opportunities: [] as Array<IProjectAttributes>,
  opportunitiesRefetching: false,
  applicationData: { casting_role_id: '', profile_id: '' },
  appliedRoles: [] as string[],

  appliedFetching: false,
  fetchMoreApplied: () => {},
  appliedDataState: [] as Array<IProjectAttributes>,
  appliedRefetching: false,
  getAppliedOpportunities: () => {},
  pushProjectToApplied: () => {},

  notInterestedFetching: false,
  fetchMoreNotInterested: () => {},
  notInterestedDataState: [] as Array<IProjectAttributes>,
  notInterestedRefetching: false,
  getNotInterestedOpportunities: () => {},
  reactivateProject: () => {},

  projectRolesData: [] as IRoleAttributes[],
  projectRolesLoading: false,
  fetchMoreProjectRoles: () => {},
  projectRolesRefetching: false,
  getProjectRolesData: () => {},

  openOpportunityModal: () => {},
  isJobs: () => false,
  shrink: false,
  setShrink: () => {},
  removeProject: () => {},
  applyToRole: () => Promise.resolve(false),
};
